import styled from '@mui/material/styles/styled'
import { Button } from '@mui/material'

export const ColorButton = styled(Button)(() => ({
    color: '#141414',
    fontFamily: "League Gothic, sans-serif",
    backgroundColor: '#DEDEDC',
    fontWeight: 700,
    fontSize: 26,
    '&:hover': {
        backgroundColor: '#2F3B49',
        color: '#FAFAFA',
    },
}))

export const ColorBorderButton = styled(Button)(() => ({
    color: '#141414',
    borderColor: '#141414',
    fontFamily: "League Gothic, sans-serif",
    fontWeight: 700,
    '&:hover': {
        backgroundColor: '#2F3B49',
        borderColor: '#2F3B49',
        color: '#FAFAFA',
    },
}))